import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../app/SliceUtils";

export const fetchTimetables = createAsyncThunk(
    '/api/timetableManagement/timetables',
    (args, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/timetableManagement/timetables`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchTimetable = createAsyncThunk(
    '/api/timetableManagement/timetable/timetableId',
    (timetableId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/timetableManagement/timetables/${timetableId}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchTimetableComplete = createAsyncThunk(
    '/api/timetableManagement/timetableComplete/timetableId',
    (timetableId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/timetableManagement/timetableComplete/${timetableId}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const postTimetable = createAsyncThunk(
    '/api/timetableManagement/timetable/post',
    (newTimetable, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/timetableManagement/timetable`, method: 'POST', body: newTimetable }, rejectWithValue)
);

export const postTimetableMoments = createAsyncThunk(
    '/api/timetableManagement/timetableMoments/post',
    (newTimetableMomentsData, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/timetableManagement/timetableMoments`, method: 'POST', body: newTimetableMomentsData }, rejectWithValue)
);

export const putTimetable = createAsyncThunk(
    '/api/timetableManagement/timetable/put',
    (updatedTimetable, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/timetableManagement/timetable`, method: 'PUT', body: updatedTimetable }, rejectWithValue)
);

export const deleteTimetable = createAsyncThunk(
    '/api/timetableManagement/timetable/delete',
    (timetableId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/timetableManagement/timetable/${timetableId}`, method: 'DELETE' }, rejectWithValue)
);

export const deleteTimetableMoments = createAsyncThunk(
    '/api/timetableManagement/timetableMoments/delete',
    (timetableId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/timetableManagement/timetableMoments/${timetableId}`, method: 'DELETE' }, rejectWithValue)
);

export const deleteTimetableMoment = createAsyncThunk(
    '/api/timetableManagement/timetableMoment/delete',
    (timetableMomentId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/timetableManagement/timetableMoment/${timetableMomentId}`, method: 'DELETE' }, rejectWithValue)
);

export const timetableManagementSlice = createSlice({
    name: 'timetableManagement',
    initialState: {
        timetables: { data: null, status: null },
        timetable: { data: null, status: null },
        timetableComplete: { data: null, status: null },
        timetablePost: { data: null, status: null },
        timetableMomentsPost: { data: null, status: null },
        timetablePut: { data: null, status: null },
        timetableDelete: { data: null, status: null },
        timetableMomentsDelete: { data: null, status: null },
        timetableMomentDelete: { data: null, status: null },
        selectedTimetable: null
    },
    reducers: {
        resetTimetableManagementStatus: (state) => {
            ResetSliceState(state, ['timetablePut', 'timetablePost', 'timetableDelete']);
        },
        resetTimetableMomentManagementStatus: (state) => {
            ResetSliceState(state, ['timetableMomentsPost', 'timetableMomentsDelete', 'timetableMomentDelete']);
        },
        selectTimetable: (state, action) => {
            state.selectedTimetable = action.payload;
        },
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchTimetables, 'timetables');
        CreateAsyncStatusHandler(builder, fetchTimetable, 'timetable');
        CreateAsyncStatusHandler(builder, fetchTimetableComplete, 'timetableComplete');
        CreateAsyncStatusHandler(builder, postTimetable, 'timetablePost');
        CreateAsyncStatusHandler(builder, postTimetableMoments, 'timetableMomentsPost');
        CreateAsyncStatusHandler(builder, putTimetable, 'timetablePut');
        CreateAsyncStatusHandler(builder, deleteTimetable, 'timetableDelete');
        CreateAsyncStatusHandler(builder, deleteTimetableMoments, 'timetableMomentsDelete');
        CreateAsyncStatusHandler(builder, deleteTimetableMoment, 'timetableMomentDelete');
    },
});

export const { resetTimetableManagementStatus, resetTimetableMomentManagementStatus, selectTimetable } = timetableManagementSlice.actions;

export default timetableManagementSlice.reducer;